import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap, ReplaySubject } from 'rxjs';
import { BackendListModel } from '../models/common/list.model';
import { LastPasswordChangedModel } from '../models/common/myteam-model';
import { PutTwoFactorAuthModel, TwoFactorAuthModel } from '../models/common/two-fact-auth-model';
import { ApiRoutes } from './apiroutes';
// import { User } from '../components/dashboard1/user-profile/user';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  base_url = ApiRoutes.Authentication;
  arthakosh_base_url = ApiRoutes.Arthakosh;
  currentDate = new Date();
  // defaultFontSize:string= 'medium';
  defaultFontSize: string = '14px';

  profile_pic = null;
  profile_pic_changed = new ReplaySubject(null);

  redirectToUrl: string = '/dashboards/dashboard1';
  _defaultRedirectUrl = '/dashboards/dashboard1';
  redirectToUrlExt: string = '/client-dashboard/my-orders';
  _defaultRedirectUrlExt = '/client-dashboard/my-orders';

  constructor(private http: HttpClient, public router: Router) {
    let profile_pic = JSON.parse(localStorage.getItem('current_user'))?.profile_picture;

    if (profile_pic != null) {
      this.profile_pic = profile_pic;
      this.profile_pic_changed.next(profile_pic);
    }
    // document.documentElement.style?.setProperty('--regular-font-size', this.defaultFontSize);
    // setTimeout(() => {
    //   document.documentElement.style.setProperty('--regular-font-size', this.defaultFontSize);
    // }, 300);

  }

  getRedirectUrl() {
    if (this.isCustomer()) {
      let url = this.redirectToUrlExt;
      this.redirectToUrlExt = this._defaultRedirectUrlExt;
      return url;
    } else {
      let url = this.redirectToUrl;
      this.redirectToUrl = this._defaultRedirectUrl;
      return url;
    }
  }

  loginStep1(data: any) {
    let url = `${this.base_url}login/username/`;
    return this.http.post(url, data);
  }

  loginStep2(data: any) {
    let url = `${this.base_url}login/token/`;
    return this.http.post(url, data, { observe: 'response' }).pipe(tap((response: any) => {
      if (response.status == 200) {
        localStorage.setItem('access_token', response.body.access_token);
        localStorage.setItem('current_user', JSON.stringify(response.body));
        this.setProfilePic(JSON.parse(localStorage.getItem('current_user')).profile_picture);
      }
    }));
  }

  loginStep3(data: any) {
    let url = `${this.base_url}verify_two_factor_otp/`;
    return this.http.post(url, data).pipe(tap((response: any) => {
      localStorage.setItem('access_token', response.access_token);
      localStorage.setItem('current_user', JSON.stringify(response));
      this.setProfilePic(JSON.parse(localStorage.getItem('current_user')).profile_picture);
    }));
  }

  resendOtp(data: any) {
    let url = `${this.base_url}resend_two_factor_otp/`;
    return this.http.post(url, data);
  }

  setProfilePic(new_profile_pic) {
    this.profile_pic = new_profile_pic;
    let current_user = JSON.parse(localStorage.getItem('current_user'))
    current_user.profile_picture = new_profile_pic;
    localStorage.setItem('current_user', JSON.stringify(current_user));
    this.profile_pic_changed.next(new_profile_pic);
  }

  getToken() {
    return localStorage.getItem('access_token');
  }

  doLogout() {
    let removeToken = localStorage.removeItem('access_token');
    localStorage.removeItem('current_user');
    if (removeToken == null) {
      // window.location.href = 'authentication/login';
      this.router.navigateByUrl('/authentication/login')
    }
  }

  // SEND email to user with reset password link
  forgotPass(data: any) {
    let url = `${this.base_url}login/forgot-password/`;
    return this.http.post(url, data).pipe(tap((response: any) => {
      localStorage.setItem('token', response.token);
    }));
  }

  // FORGOT/RESET password if user not logged in
  resetPassFromEmail(data: any) {
    let url = `${this.base_url}login/reset-password/`;
    return this.http.post(url, data);
  }

  // CHANGE password when user logged in
  changePassword(data: any) {
    let url = `${this.base_url}reset-password/`;
    return this.http.put(url, data);
  }

  // GET authentication status for activation of Routes
  getAuthStatus(): boolean {
    let userStatus = JSON.parse(localStorage.getItem('current_user'));
    let accessTokenExpiry;

    if (userStatus != null) {
      accessTokenExpiry = new Date(userStatus.access_token_expiry);

      if (this.getToken() && accessTokenExpiry > this.currentDate) {
        return true;
      } else {
        localStorage.removeItem('access_token');
        localStorage.removeItem('current_user');
        return false;
      }
    } else {
      return false;
    }
  }

  // GET Two-Factor Authentication List
  getTwoFactAuthList(page_size = 3): Observable<BackendListModel<TwoFactorAuthModel>> {
    let url = `${this.base_url}two_fact_master/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    return this.http.get<BackendListModel<TwoFactorAuthModel>>(String(urlObj));
  }

  // PUT Two-Factor Authentication
  updateTwoFactAuth(data): Observable<PutTwoFactorAuthModel> {
    let url = `${this.base_url}enable_two_factor_auth/`;
    return this.http.put<PutTwoFactorAuthModel>(url, data);
  }

  // GET Active Two-Factor Authentication
  getActiveTwoFactAuth(): Observable<TwoFactorAuthModel> {
    let url = `${this.base_url}active_two_factor_auth/`;
    return this.http.get<TwoFactorAuthModel>(url);
  }

  // GET Password Changed Date
  getPasswordChangedDate(): Observable<LastPasswordChangedModel> {
    let url = `${this.base_url}password_changed_at/`;
    return this.http.get<LastPasswordChangedModel>(url);
  }

  // GET User Profile
  getUserProfile() {
    return JSON.parse(localStorage.getItem('current_user'));
  }

  // Check Token validity for Set/Reset Password
  tokenValidity(token) {
    let url = `${this.base_url}login/reset-password/validity/`;
    return this.http.post(url, token);
  }

  // Check if logged in user is customer //impressive
  isCustomer(): boolean {
    if (JSON.parse(localStorage.getItem('current_user'))?.role === 'customer') {
      return true;
    }
    return false;
  }

  getAuthQR(token) {
    let url = `${this.base_url}authenticator_qr/`;
    return this.http.post(url, token, { responseType: 'blob' });
  }

  fetchExternalAppLoginToken(){
    let url=`${this.arthakosh_base_url}fetch_login_token/`;
    return this.http.get<any>(url)
  }
}
